// extracted by mini-css-extract-plugin
module.exports = {"input":"IndicateReasonReturn_input_1LtuA","switcher":"IndicateReasonReturn_switcher_21Z86"};